import { SectionBanner, useHomepage } from "../../pages";
import React from "react";
import { ButtonLink } from "../Button";
import { CommonTranslation } from "../CommonTranslations";
import { AMAZON_SHOP_URL } from "../../client-links";

export default function ShopBanner() {
  const { shop } = useHomepage();
  return (
    <SectionBanner banner={shop}>
      <div className="mt-8">
        <ButtonLink className="inline py-2" to={AMAZON_SHOP_URL}>
          <CommonTranslation value="shop" />
        </ButtonLink>
      </div>
    </SectionBanner>
  );
}
